import { obj } from '../utility/tools.js';

export class StoredGlobal {
    constructor(name, initialValue) {
        this._storageKey = `lag:globals.${name}`;
        this._changeListeners = [];

        if (initialValue !== undefined)
            this.set(initialValue);
        else
            this._load();

        StoredGlobal._initStorageChangeListenerAndAddInstance(this);
    }

    get valid() {
        return this._cachedData !== undefined && this._cachedData !== null;
    }

    get(key) {
        const isKeyValid = key && (key.length > 0) && (this._cachedData instanceof Object);

        return this._getValueCopy(
            isKeyValid ? this._cachedData[key] : this._cachedData
        );
    }
    _getValueCopy(value) {
        if (value && value instanceof Object) {
            // We don't want to give mutable access to the object, so we copy it using Object.assign (as normal assignment is shallow).
            // HACK: We're only doing Object.assign on top level, so multi-level objects are mutable at lower levels.
            return Object.assign({}, value);
        }

        // Not an object, can just return the value directly.
        return value;
    }

    set(val) {
        // Don't allow undefined, normalize to null.
        if (val === undefined)
            val = null;

        // If data is the same then don't update (nor trigger on-change).
        if (obj.is.alike(this._cachedData, val))
            return;

        // Store the value locally in our cache and in storage.
        this._cachedData = val;
        localStorage.setItem(this._storageKey, JSON.stringify(this._cachedData)); // Stringify data to put into storage.

        // Trigger on-change.
        this._triggerChangeListeners();
    }

    addChangeListener(listener) {
        if (typeof (listener) !== 'function')
            throw new Error('globals.StoredGlobal.addChangeListener{not-a-function}');

        this.removeChangeListener(listener); // Only allow unique listeners (no duplicates).
        this._changeListeners.push(listener);
    }
    removeChangeListener(listener) {
        let c = this._changeListeners.length;
        while (--c >= 0) {
            const f = this._changeListeners[c];
            if (f === listener) this._changeListeners = this._changeListeners.splice(c, 1);
        }
    }

    _load() {
        const storedData = JSON.parse(localStorage.getItem(this._storageKey));

        if (obj.is.alike(this._cachedData, storedData))
            return; // Not changed so nothing to do, exit (don't trigger change listeners).

        this._cachedData = storedData;
        this._triggerChangeListeners();
    }

    _triggerChangeListeners() {
        const dataCopy = this.get(); // Makes a copy so our copy cannot be changed.
        // Should we be making a separate copy for each listener? currently if calling-code changes it's copy then changes all copies.

        for (const f of this._changeListeners) {
            f(dataCopy);
        }
    }

    static _initStorageChangeListenerAndAddInstance(instance) {
        // Shared instances array has not been initialized (this means storage event listener has also not been intialized).
        if (!StoredGlobal._instances) {
            StoredGlobal._instances = [];

            window.addEventListener('storage', (e) => {
                // NOTE: 2023-11-2 - This is a hack to prevent the storage event from firing when we set local application state variables
                if (e.key.includes("app:")) return;

                for (const sg of StoredGlobal._instances) {
                    sg._load(); // Tell instances of StoredGlobal to check/re-load data from storage.
                }
            });
        }

        // Add this instance to the shared instances array.
        // The instance will be told to load its data from storage when storage event occurs.
        StoredGlobal._instances.push(instance);
    }
};